import { array } from "prop-types";
import React from "react";

import NewsWithImage from "../../../molecules/NewsWithImage";

import "./organism2.m.css";

const Organism2 = ({ storyList = [] }) => {
  if (!storyList.length) return null;
  return (
    <div styleName="base">
      {storyList.map(({ story }, index) => (
        <NewsWithImage story={story} key={index} widths={[290, 280, 390]} />
      ))}
    </div>
  );
};

Organism2.propTypes = {
  storyList: array.isRequired,
};

export default Organism2;
